module.exports = __webpack_public_path__ + "assets/webgl/neons.de3cba77.jpg";